import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../lib/api";

/**
 * On boot, hits /api/geo/check. If blocked, render a hard redirect to /blocked.
 * Otherwise renders children. Skips the check when already on /blocked.
 */
export default function GeoGuard({ children }) {
  const [state, setState] = useState("checking"); // checking | ok | blocked
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.pathname === "/blocked") {
      setState("ok");
      return;
    }
    (async () => {
      try {
        const { data } = await api.get("/geo/check");
        setState(data?.blocked ? "blocked" : "ok");
      } catch {
        // fail-open on network hiccup — server enforces geo policy on signup/login anyway
        setState("ok");
      }
    })();
  }, []);

  if (state === "checking") {
    return (
      <div className="bg-shell min-h-screen flex items-center justify-center text-[color:var(--muted)] text-xs tracking-[0.3em] uppercase" data-testid="geo-checking">
        Locating…
      </div>
    );
  }
  if (state === "blocked") return <Navigate to="/blocked" replace />;
  return children;
}
